import { PostOrderOpp, PostCreate } from "services/apiService";
import {
  ORDEROPPORTUNITIES_MANUAL_ORDER_REQUEST,
  ORDEROPPORTUNITIES_MANUAL_ORDER_SUCCESS,
  ORDEROPPORTUNITIES_MANUAL_ORDER_ERROR,
  CREATE_MANUAL_ORDERS_REQUEST,
  CREATE_MANUAL_ORDERS_SUCCESS,
  CREATE_MANUAL_ORDERS_ERROR,
  RESET_CREATE_MANUAL_ORDER,
  RESET_ORDEROPPORTUNITIES_MANUAL_ORDER,
  RESET_CREATE_MANUAL_ORDER_ERROR,
  SEARCH_ORDEROPPORTUNITIES_SUCCESS,
  SEARCH_ORDEROPPORTUNITIES_REQUEST,
  SEARCH_ORDEROPPORTUNITIES_ERROR,
  SEARCH_ORDEROPPORTUNITIES_RESET,
} from "./action-type";
import { ORDER_OPPORTUNITIES_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
export const orderOpportunitiesInCreate =
  ({ limit, offset, payload }) =>
    
  async (dispatch) => {
    const apiUrl = `orderopportunities/@lookup?apikey=${SOMS_API_KEY}&offset=${offset}&limit=${limit}`;
    dispatch({ type: ORDEROPPORTUNITIES_MANUAL_ORDER_REQUEST });

    PostOrderOpp(
      apiUrl,payload,
    )
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: ORDEROPPORTUNITIES_MANUAL_ORDER_SUCCESS,
            payload: response.data,
          });
        } else {
          dispatch({
            type: ORDEROPPORTUNITIES_MANUAL_ORDER_ERROR,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: ORDEROPPORTUNITIES_MANUAL_ORDER_ERROR,
          payload: error.response.data,
        });
      });
  };

export const resetOrderOpportunities = () => {
  return {
    type: RESET_ORDEROPPORTUNITIES_MANUAL_ORDER,
  };
};

export const createManualOrdersForSiteCanteen = (
  payload,
  orderType,
  action
) => {
  const apiEndPointUrl = `orders/@processorders?orderType=${orderType}&action=${action}&apikey=${SOMS_API_KEY}`;
  
  return (dispatch) => {
    dispatch(createManualOrderRequest);
    PostCreate(apiEndPointUrl, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(createManualOrderSuccess(response));
        } else {
          dispatch(createManualOrderError(response));
        }
      })
      .catch((error) => {
        createManualOrderError(error);
      });
  };
};

export const createManualOrders = (payload, email) => {
  const apiEndPointUrl = `orders/@processorders?orderType=central-supplychain&action=create`;
 
  return (dispatch) => {
    dispatch(createManualOrderRequest);
    PostCreate(apiEndPointUrl, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(createManualOrderSuccess(response));
        } else {
          dispatch(createManualOrderError(response));
        }
      })
      .catch((error) => {
        createManualOrderError(error);
      });
  };
};

export const createManualOrderSuccess = (response) => {
  return {
    type: CREATE_MANUAL_ORDERS_SUCCESS,
    createManualOrderResponse: response.data,
    isCreateManualOrderError: false,
    isCreateManualOrderSuccess: true,
  };
};

export const createManualOrderRequest = () => {
  return {
    type: CREATE_MANUAL_ORDERS_REQUEST,
  };
};

export const createManualOrderError = (error) => {
  return {
    type: CREATE_MANUAL_ORDERS_ERROR,
    createManualOrderResponse: error,
    isCreateManualOrderError: true,
    isCreateManualOrderSuccess: false,
  };
};

export const resetCreateManualOrder = () => {
  return {
    type: RESET_CREATE_MANUAL_ORDER,
  };
};
export const resetCreateManualOrderError = () => {
  return {
    type: RESET_CREATE_MANUAL_ORDER_ERROR,
  };
};

export const searchOrderOpportunities = (payload, limit, offset) => {
    const apiEndPointUrl = `${ORDER_OPPORTUNITIES_ENDPOINT}?isStoreUser=true&limit=${limit}&offset=${offset}&apikey=${SOMS_API_KEY}`
    return (dispatch) => {
        dispatch(searchOrderOpportunitiesRequest());
        PostOrderOpp(apiEndPointUrl, payload)
            .then((response) => {
                if (response.status === 200)
                    dispatch(searchOrderOpportunitiesSuccess(response));
                else
                    dispatch(searchOrderOpportunitiesError(response));
            })
            .catch((err) => {
                dispatch(searchOrderOpportunitiesError(err));
            });

    };
};

export const searchOrderOpportunitiesSuccess = (response) => {
  return {
    type: SEARCH_ORDEROPPORTUNITIES_SUCCESS,
    searchOrderOpportunitiesResponse: response.data,
    isSearchOrderOpportunitiesError: false,
    isSearchOrderOpportunitiesSuccess: true,
  };
};

export const searchOrderOpportunitiesRequest = () => {
  return {
    type: SEARCH_ORDEROPPORTUNITIES_REQUEST,
  };
};

export const searchOrderOpportunitiesError = (error) => {
  return {
    type: SEARCH_ORDEROPPORTUNITIES_ERROR,
    searchOrderOpportunitiesResponse: error,
    isSearchOrderOpportunitiesError: true,
    isSearchOrderOpportunitiesSuccess: false,
  };
};

export const searchOrderOpportunitiesReset = () => {
  return {
    type: SEARCH_ORDEROPPORTUNITIES_RESET,
  };
};
